/**
 * All Indonesian (Bahasa Indonesia) copy for the kiosk.
 * Centralized so components hold no hardcoded strings — positions us for
 * future i18n without doing the full work now. Source: Hanami design pack
 * (Kios K SVG mockups).
 */
export const id = {
  welcome: {
    heroTitle: 'ORDER HERE',
    subtitle: 'Pesan sendiri, cepat dan mudah',
    cta: 'Pesan Sekarang',
  },

  menu: {
    headerSubtitle: 'Pilih menu favoritmu di sini',
    soldOut: 'HABIS',
    selectedCount: (n: number) => `${n} item dipilih`,
    customCount: (n: number) => `${n} kustom`,
  },

  cartBar: {
    summary: 'Tekan untuk lanjut',
    itemCount: (n: number) => `${n} item`,
  },

  customization: {
    cancel: 'Batal',
    addToCart: '+ Tambah ke pesanan',
    price: 'Harga',
    required: '*',
  },

  cart: {
    title: 'Keranjang',
    colMenu: 'Menu',
    colHarga: 'Harga',
    colJumlah: 'Jumlah',
    colSubTotal: 'Sub Total',
    total: 'TOTAL',
    backToMenu: 'Kembali ke Menu',
    checkoutCta: 'Lanjut ke Check Out',
    modifierLabel: (group: string, option: string) => `${group}: ${option}`,
    empty: {
      title: 'Keranjang kosong',
      subtitle: 'Pilih menu untuk mulai memesan.',
      cta: 'Lihat Menu',
    },
  },

  confirmation: {
    title: 'Check Out',
    rincianPesanan: 'Rincian Pesanan',
    ringkasanPesanan: 'Ringkasan Pesanan',
    subTotal: 'Sub Total',
    pajak: 'Pajak',
    total: 'Total',
    payAtCounterTitle: 'Bayar di Counter',
    payAtCounterBody:
      'Struk dengan nomor pesanan akan tercetak. Bawa struk ke counter untuk pembayaran.',
    payAtCounterValidity: 'Berlaku 15 menit setelah cetak.',
    printCta: 'Buat Pesanan',
    backToCart: 'Kembali ke Keranjang',
    priceUpdated: 'Harga diperbarui',
    itemsUnavailable: 'Beberapa item tidak lagi tersedia. Silakan tinjau pesanan.',
  },

  instructions: {
    titlePrinting: 'Mencetak Struk…',
    printingBody: 'Mohon tunggu, struk sedang dicetak',
    titlePrinted: 'Struk Tercetak',
    titleFailed: 'Struk Gagal',
    showAtCounter: 'Tunjukkan nomor ini di counter',
    receiptUnpaid: 'BELUM DIBAYAR',
    steps: [
      'Ambil struk yang tercetak',
      'Serahkan struk ke counter',
      'Lakukan pembayaran (tunai / non-tunai)',
      'Terima calling device / tunggu dipanggil',
    ],
    validUntil: (time: string) => `Berlaku hingga ${time} WITA`,
    newTransaction: 'Transaksi Baru',
    printFailedTitle: 'Struk gagal dicetak',
    printFailedBody: 'Tunjukkan layar ini ke counter — struk akan dicetak ulang.',
    qrLabel: (orderNo: string) => `Kode QR nomor pesanan ${orderNo}`,
  },

  receipt: {
    outletName: 'HANAMI SPACE',
    outletTagline: 'Smart Cafe - Makassar',
    orderIdLabel: 'Order ID',
    dateLabel: 'Tanggal',
    timeLabel: 'Jam',
    timezoneSuffix: 'WITA',
    colItem: 'ITEM',
    colQtyPrice: 'QTY X HARGA',
    colTotal: 'TOTAL',
    totalLabel: 'TOTAL',
    paymentStatusLabel: 'STATUS PEMBAYARAN',
    qrHint: 'Tunjukkan QR Code ini kepada staf Hanami untuk cek status order',
    wifiTitle: 'WIFI HANAMI',
    ssidLabel: 'SSID',
    passwordLabel: 'PASSWORD',
    thanks: 'Terima kasih',
  },

  idle: {
    title: 'Masih di sini?',
    subtitle: 'Tap untuk melanjutkan pesanan.',
    continue: (seconds: number) => `Lanjutkan (${seconds})`,
  },

  toast: {
    addedToCart: 'Ditambahkan ke keranjang',
    printerOffline: 'Printer tidak terhubung',
  },

  banner: {
    offline: 'Pesanan sementara tidak tersedia — coba lagi sebentar',
  },

  badge: {
    paid: 'PAID',
    void: 'VOID',
    new: 'Baru',
    bestseller: 'Bestseller',
  },

  common: {
    back: 'Kembali',
    rupiahPrefix: 'Rp',
    loading: 'Memuat…',
    errorTitle: 'Terjadi kesalahan',
    errorBody: 'Silakan ulangi atau hubungi staf.',
  },

  // Shown when this tablet's config.json is missing or invalid. The kiosk
  // deliberately refuses to start rather than fall back to a default identity,
  // which would mis-attribute orders and print on the wrong printer.
  kioskConfig: {
    errorTitle: 'Kiosk belum dikonfigurasi',
    errorBody: 'Hubungi staf. Perangkat ini belum terhubung ke kios manapun.',
  },
} as const;

export type Strings = typeof id;
